type SortableObject = {
  [key: string]: any;
  active: boolean;
  name?: string;
};

export const sortListItemsByActiveStatus = (
  a: SortableObject,
  b: SortableObject,
): number => {
  // Sort by active status (active ones first)
  if (a.active !== b.active) {
    return a.active ? -1 : 1; // Sort active items before inactive items
  }

  // If both items have the same active status, sort by name if available
  if (a.name && b.name) {
    return a.name.localeCompare(b.name); // Sort alphabetically by name
  }

  // Default case (no specific order for items without name or same name)
  return 0;
};

export const validateCustomerNumber = (customerNumber: string): boolean => {
  // Customer number needs to start with capital 'C' letter.
  const regex = /^[C][0-9]*$/;
  return regex.test(customerNumber);
};

export const isEmptyPhoneNumber = (phone: string | undefined | null): boolean =>
  !phone || phone.trim() === "+358";
